import common from '../../common/common'
import { Commun} from '../../utils/axios'

const getKnoList = params => {
    return Commun.get('/api/video/note/list', params)
}
const getQuizList = params => {
    return Commun.get('/api/classroom/quiz/list', params)
}
const addKnoPoint = data => {
    return Commun.post('/api/video/note/add', data)
}
const editKnowPoint = data => {
    return Commun.post('/api/video/note/edit', data)
}
const delKnoPoint = params => {
    return Commun.post('/api/video/note/delete', params)
}
const getRecordDetail = params => {
    return Commun.get('/api/video/record/detail', params)
}
const onStarReward = params => {
    return Commun.post('/api/video/star/add', params)
}
const getReplayInfo = params => {
    return Commun.get('/api/video/config', params)
}
// 聊天记录
const getChatRecordList = params => {
    return Commun.get('/api/chat-record/list', params)
}
const getShareUrl = params => {
    return Commun.get('/api/video/note/share-url', params)
}
const getClassroom = params => {
    return Commun.get('/api/client/module/info', params)
}
// 获取参数
const getBoardsinfo = params => {
    return Commun.post('/api/client/h5/config/pandora/boards', params)
}
const getMediaInfo = classroomId => {
    return Commun.get(`/api/client/media/${classroomId}/info`)
}
// 获取长期有效token
const getEffectiveToken = (token) => {
    return Commun.get(`/api/login/fetchToken/${token}`);
}
// 获取讲义下载地址
const getHandoutInfo = params => {
    return Commun.get(`/api/video/zx-lecture`, params);
}
const getExternalQuestion = params => {
    return Commun.get('/api/client/external-question/info', params);
}
// 判断是否为游客
const getIsTour = params => {
    return Commun.get('/api/client/module/info/playback', params);
}

const sendApp = (agreement, jsonStr) => {
    console.log(agreement, jsonStr, 'sendApp');
    if (window.Sac_jsCallC) {
        window.Sac_jsCallC(agreement, jsonStr);
    } else {
        let obj = {};
        obj[agreement] = jsonStr;
        window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
    }
    // if (navigator.userAgent.indexOf("Window") > 0  || navigator.userAgent.indexOf("Name/xdf-browser") > 0) {
    //     window.Sac_jsCallC(agreement, jsonStr);
    //     return;
    // }
    // if (navigator.userAgent.indexOf("Mac OS X") > 0) {
    //     let obj = {};
    //     obj[agreement] = jsonStr;
    //     window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
    // }
}
const closeWindow = (agreement, jsonStr) => {
    console.log(agreement, jsonStr, 'closeWindow');
    if (window.Sac_jsCallC) {
        window.Sac_jsCallC(agreement, jsonStr);
    } else {
        let obj = {};
        obj[agreement] = jsonStr;
        window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
    }

    // if (navigator.userAgent.indexOf("Window") > 0 || navigator.userAgent.indexOf("Name/xdf-browser") > 0) {
    //     window.Sac_jsCallC(agreement, jsonStr);
    //     return;
    // }
    // if (navigator.userAgent.indexOf("Mac OS X") > 0) {
    //     let obj = {};
    //     obj[agreement] = jsonStr;
    //     window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
    // }
}

const knowPointService = {
    getKnoList,
    getQuizList,
    addKnoPoint,
    editKnowPoint,
    delKnoPoint,
    onStarReward,
    getReplayInfo,
    getRecordDetail,
    getChatRecordList,
    sendApp,
    closeWindow,
    getShareUrl,
    getClassroom,
    getBoardsinfo,
    getMediaInfo,
    getEffectiveToken,
    getHandoutInfo,
    getExternalQuestion,
    getIsTour
}
export default knowPointService